<script setup>
import { Primitive } from "reka-ui";
import { computed } from "vue";

import SvgIcon from "../SvgIcon.vue";
// Designs: https://www.figma.com/design/2p4V4umhowH517CmLk2WUn/Components?node-id=5260-3421&t=A5KTIJRWJVu1IJ3d-0

const props = defineProps({
  // Primitive props — render as any tag, or merge onto a child via asChild
  as: { type: [String, Object], default: "span" },
  asChild: { type: Boolean, default: false },

  icon: { type: String, required: false, default: undefined },

  color: {
    type: String,
    default: "grey",
    validator: (v) => ["primary", "grey", "red"].includes(v),
  },
  size: {
    type: String,
    default: "small",
    validator: (v) => ["small", "x-small"].includes(v),
  },
});

const iconSize = computed(() => {
  switch (props.size) {
    case "x-small":
      return "12";
    case "small":
    default:
      return "14";
  }
});
</script>

<template>
  <Primitive :as :as-child class="badge" :class="[color, size]">
    <SvgIcon v-if="icon" :name="icon" :width="iconSize" :height="iconSize" />
    <span class="text">
      <slot />
    </span>
  </Primitive>
</template>

<style lang="scss" scoped>
@use "@/colors" as c;
@use "@/styles/mixins/typography";

.badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 4px;

  // --- Size Variants ---

  &.x-small {
    @include typography.extra-small("semi-bold");

    padding: 2px 4px;
  }

  &.small {
    @include typography.small("semi-bold");

    padding: 4px;
  }

  // --- Color Variants ---

  &.primary {
    color: c.$text-inverse;
    background-color: c.$main;
  }

  &.grey {
    color: c.$text;
    background-color: c.$grey-lighter;
  }

  &.red {
    color: c.$brand-danger;
    background: rgba(c.$brand-danger, 0.08);
  }
}
</style>
